import {
  GET_QUESTION_BANKS,
  FETCH_QUESTION_BANK,
  ADD_QUESTION_BANK,
  UPDATE_QUESTION_BANK,
  DELETE_QUESTION_BANK,
  CLEAR_QUESTION_BANKS,
  QUESTION_BANKS_PAGE,
  CLEAR_ALL,
  QUESTION_BANKS_PENDING, // Added pending action type
} from "../constants/actions";

const initialState = {
  question_banks: [],
  pending: false,
  pageNumber: 1,
  created: false,
  updated: false,
};

export default function questionBanks(state = initialState, action) {
  switch (action.type) {
    case QUESTION_BANKS_PENDING: // Added pending case
      return {
        ...state,
        pending: true,
      };
    case GET_QUESTION_BANKS:
      return {
        ...state,
        question_banks: action.payload,
        pending: false,
      };
    case QUESTION_BANKS_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case FETCH_QUESTION_BANK:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case ADD_QUESTION_BANK:
      return {
        ...state,
        created: action.payload,
        pending: false,
      };
    case UPDATE_QUESTION_BANK:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case DELETE_QUESTION_BANK:
      return {
        ...state,
        updated: Math.random(),
        pending: false,
      };
    case CLEAR_QUESTION_BANKS:
      return {
        ...state,
        ...initialState,
      };
    case CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}